import { render, staticRenderFns } from "./SolicitacoesRelatoriosMenu.vue?vue&type=template&id=2eb8663d&"
import script from "./SolicitacoesRelatoriosMenu.vue?vue&type=script&lang=js&"
export * from "./SolicitacoesRelatoriosMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports